import QuizService from '../../services/quizService';
import { quizStart } from '../quiz/actions';

export const LOGIN_LOADING = 'LOGIN_LOADING';
export const LOGIN_LOGOUT = 'LOGIN_LOGOUT';
export const LOGIN_ERROR = 'LOGIN_ERROR';

import quizData from '../../../content/quiz.json';

export function loginAction({ schoolCode, classNumber, questions }) {
  return async dispatch => {
    dispatch({
      type: LOGIN_LOADING,
    });

    try {
      const response = await QuizService.authStudent({ schoolCode, classNumber });
      const studentId = response['student_id'];
      const authError = response['__all__'] || response['name'];

      if (!studentId) {
        throw new Error(
          authError ||
            'Wpisana nazwa została już użyta przez kogoś innego lub jest niepoprawna. Wymyśl inną nazwę i wpisz ponownie, a następnie Rozpocznij test.'
        );
      }

      dispatch(
        quizStart({
          schoolCode,
          classNumber,
          studentId,
          questions,
        })
      );
    } catch (error) {
      dispatch({
        type: LOGIN_ERROR,
        payload: {
          schoolCode,
          classNumber,
          error: error.message,
        },
      });
    }
  };
}

export function logoutAction() {
  return {
    type: LOGIN_LOGOUT,
  };
}
